<template>
  <div class="filter-box my-3 p-3 bg-white rounded shadow-sm">
    <button class="filter-header btn btn-link mb-0"
            data-toggle="collapse"
            :data-target="`#${id}`"
            :aria-expanded="expanded"
            :aria-controls="id"
            :class="{collapsed:!expanded}">
      <i class="fa" aria-hidden="true"></i> {{ title }}
    </button>

    <div class="filter-content collapse" :id="id" :class="{show:expanded}">
      <slot></slot>
    </div>
  </div>
</template>

<script>

    export default {
        name: 'FilterBox',
        computed: {
            locale() {
                return this.$i18n.locale
            },
        },
        props: {
            title: {
                type: String,
                required: true
            },
            expanded: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data: () => ({
            id: null
        }),
        mounted() {
            this.id = `collapseFilterBox${this._uid}`;
        },

    }
</script>

<style lang="scss">
  [data-toggle="collapse"] .fa:before {
    content: "\f139";
  }

  [data-toggle="collapse"].collapsed .fa:before {
    content: "\f13a";
  }

  .filter-header {
    padding: 0;
  }

  .filter-content {
    margin-top: 10px;
    /*border-top: 1px solid #dee2e6 !important;*/
  }
</style>